export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-03.5a109666.png";